import type { FaireProductEntity } from "../../entity_types/product";

export const p_7w54dbs6pp: FaireProductEntity = {
  token: "p_7w54dbs6pp",
  type: "product",
  name: "Stitch Marker Earrings",
  brandToken: "b_b5dlwpia46",
  brandName: "Coco Clem",
  imageUrl:
    "https://cdn.faire.com/fastly/2098eb9d4adef532d60cbea3b43c45b5fa519539b7a66394427ecf667ce2c706.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4deb677dc3718a4b2598933e1b8f2608b0506c29212c261fa26533e6db6c0661.jpeg",
    "https://cdn.faire.com/fastly/974c7786cb05f9027a276416669d5a420233d81f6936848efc6acd88fcf033db.jpeg",
    "https://cdn.faire.com/fastly/aae3abf4d6b5f451de67841987c02b4b9f69c1d52d550d3bbf49207e229ffd8b.jpeg",
    "https://cdn.faire.com/fastly/608d81e1d0a124660168370668dfac908d61b727cf7b96b9e8d1d2babaace1b1.jpeg",
    "https://cdn.faire.com/fastly/5559587e81f91ef7457ca21ad43738fbc3b00ab3fb92e17007e759f738b10d09.webp",
    "https://cdn.faire.com/fastly/0afa4c4d8efb263b39d579ace370d23ce4a2fe921ea1d51da805d8c1fb1f10a4.webp",
    "https://cdn.faire.com/fastly/8c4d35e40e6cca036c1d25997ae09ddd085d2dfe7075f08b432123570eda9ba9.webp",
    "https://cdn.faire.com/fastly/f88a4d52d8d76169961c6774133fe49678f1fdafad5051d4ac5bd6d772536a9d.webp",
    "https://cdn.faire.com/fastly/d616b11bf40eef7ee5e1eb85673340d23eabb3ad984a75270871c5c57655b37d.jpeg",
    "https://cdn.faire.com/fastly/6bd4137b3802bd6011f0f44da04a6f5930bf266ae2466af34cdfb2a64f58fe76.png",
    "https://cdn.faire.com/fastly/d8c8df9012cbdc23f2a229aa9d7065663583e5305ffa845440bfb11b01e74161.webp",
    "https://cdn.faire.com/fastly/f4155ccec4fcd951be10b9fba136bbc919c0f2318138cd246e4db3a11b3ec1be.jpeg",
  ],
  priceDollars: 31,
  description:
    "Whether you're mid-row or mid-life crisis, our Stainless Steel Stitch Marker Earrings are here for the moment you swore you'd remember the increase, but thought about that time in 4th grade when someone said you breathe weird, instead. Perfect for knitters and crocheters alike, these earrings offer a fun nod to the tools of your trade.\n\n• 316L Stainless Steel / 18K Gold PVD Coated 316L Stainless Steel / Enamel Coated Stainless Steel\n• Length: 22mm\n• Post Length: 6mm\n• Gauge: 18g\n• Weight: 3g\n• Hypoallergenic & safe for sensitive skin\n• Tarnish-resistant, water-friendly, and durable\n• Designed in NC / Imported\n• Crafted by a Responsible Jewellry Council certified manufacturer\n",
  tags: [],
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:42.919Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
